import React from "react";
import { toast } from "react-semantic-toasts";
import pluralize from "pluralize";
import { Message } from "semantic-ui-react";

import { StampStatuses } from "utilities/dist/stamp/constants";

export const showSummaryToast = (response = [], validatedStampData = {}) => {
    const summary = [];
    let totalDestroyedCount = 0;

    if (response && response.length) {
        response.forEach(({ status, total, invoice_numbers = [] }) => {
            const countText = pluralize("stamp", total, true);
            if (status === StampStatuses.INVOICED) {
                let summaryText = `${countText} NOT destroyed because they are in INVOICED status.`;
                if (invoice_numbers?.length) {
                    summaryText += ` Invoices: #${invoice_numbers.join(", #")}`;
                }
                summary.push(summaryText);
            }
            if (status === StampStatuses.DESTROYED) {
                summary.push(`${countText} NOT destroyed because they were already DESTROYED.`);
            }
            if (status === StampStatuses.AVAILABLE) {
                summary.push(
                    `${countText} destroyed and marked unavailable`,
                    `You will no longer be able to use those stamps in future invoices`
                );
                totalDestroyedCount = total;
            }
        });
    }

    // This means there were not stamp count grouped by status were returned so no available stamps found
    if (!totalDestroyedCount) {
        summary.push(
            `No stamps were destroyed in the given range ${validatedStampData.to} - ${validatedStampData.from}`
        );
    }

    const toastType = totalDestroyedCount ? "success" : "warning";
    const toastTitle = totalDestroyedCount
        ? `${pluralize("Stamp", totalDestroyedCount, true)} destroyed`
        : `No stamp destroyed`;

    toast({
        time: 15000,
        icon: "ticket",
        type: toastType,
        title: (
            <h4 data-cy={`destroy_stamps_${toastType}_toast_title`} style={{ marginBottom: 0 }}>
                {toastTitle}
            </h4>
        ),
        description: (
            <div data-cy={`destroy_stamps_${toastType}_toast_description`}>
                <Message.List>
                    {summary.map(item => (
                        <Message.Item key={item}>{item}</Message.Item>
                    ))}
                </Message.List>
            </div>
        ),
    });
};
